import 'dotenv/config';
export const ENVIRONMENT_IS_DEVELOPMENT = !!process.env.NEXT_PUBLIC_ENVIRONMENT_IS_DEVELOPMENT;
